import { getIsoDatestampDaysIntoThePast } from '../../helpers/dateTimeHelpers';

export const DefaultTransactionsPageLink = (): string =>
  `/transactions?startDate=${getIsoDatestampDaysIntoThePast(30)}`;
